import Controller from "./actionListTable.controller";
import template from "./actionListTable.html";

const actionListTable = {
  template,
  controller: Controller,
  bindings: {
    resource: "@",
    resourceName: "@",
    resourceId: "<",
    resourceParams: "<",
    resourceMethod: "@",
    resourceTransformer: "@",
    resourceTransformerMethod: "@",
    noItemsText: "@",
    resourceActions: "<",
    resourceActionsFilter: "@",
    fields: "<",
    state: "<",
    stateField: "@",
    reloadWhenUpdate: "@",
    filters: "<",
    hideActions: "<",
    hidePagination: "<",
    hasQuickView: "<",
    items: "<",
    total: "=?",
    actionSuccessResponseEvent: "<",
    itemActions: "<",
    tableTitle: "@?",
  },
};

export default actionListTable;



// WEBPACK FOOTER //
// ./src/components/actionListTable/actionListTable.component.js